// extracted by mini-css-extract-plugin
module.exports =  {"value-change":"_7a3fb80146--value-change--yMNQ4","icon--inner":"_7a3fb80146--icon--inner--XMM_U","tooltip":"_7a3fb80146--tooltip--pD5xJ"};